export default __webpack_public_path__ + "static/media/whatsappDark.39f53e74.png";